module.exports = __webpack_public_path__ + "img/dominica.e791b00f.svg";